import { AxiosInstance } from 'axios'
import { SUBSCRIPTIONS_ENDPOINTS } from 'api/ApiRoutes'
import {
  Coupon,
  Plan,
  SubscriptionInvoice,
  SubscriptionPayload,
  UpdateSubscriptionPayload
} from 'types/subscriptions'

class SubscriptionsApi {
  constructor(private axiosInstance: AxiosInstance) {}

  cancelSubscription = async ({
    password,
    passphrase
  }: {
    password?: string
    passphrase?: 'confirm'
  }) => {
    const body = password
      ? { verify_password: password }
      : passphrase
        ? { passphrase }
        : {}
    const d = await this.axiosInstance.post(
      SUBSCRIPTIONS_ENDPOINTS.CANCEL_SUBSCRIPTION,
      body
    )
    return d.data
  }

  getPlans = async () => {
    const d = await this.axiosInstance.get<Plan[]>(
      SUBSCRIPTIONS_ENDPOINTS.PLANS
    )
    return d.data
  }

  checkCoupon = async ({ coupon }: { coupon: string }) => {
    const d = await this.axiosInstance.post<{ coupon: Coupon }>(
      SUBSCRIPTIONS_ENDPOINTS.CHECK_COUPON,
      { coupon }
    )
    return d.data
  }

  createSubscription = async (subscription: SubscriptionPayload) => {
    const d = await this.axiosInstance.post(SUBSCRIPTIONS_ENDPOINTS.BASE, {
      subscription
    })
    return d.data
  }

  updateSubscriptionPayment = async (subscription: SubscriptionPayload) => {
    const d = await this.axiosInstance.post(
      SUBSCRIPTIONS_ENDPOINTS.UPDATE_CUSTOMER,
      {
        subscription
      }
    )
    return d.data
  }

  updateSubscription = async (subscription: UpdateSubscriptionPayload) => {
    const d = await this.axiosInstance.put(
      SUBSCRIPTIONS_ENDPOINTS.CURRENT_SUBSCRIPTION,
      {
        subscription
      }
    )
    return d.data
  }

  getSubscriptionInvoices = async ({
    starting_after
  }: {
    starting_after?: string
  } = {}) => {
    const d = await this.axiosInstance.get<SubscriptionInvoice[]>(
      SUBSCRIPTIONS_ENDPOINTS.INVOICES,
      {
        params: {
          starting_after: starting_after || undefined
        }
      }
    )
    return d.data
  }

  reactivateSubscription = () => {
    return this.axiosInstance
      .post(SUBSCRIPTIONS_ENDPOINTS.REACTIVATE_SUBSCRIPTION)
      .then((d) => d.data)
  }

  getStripeClientSecret = () => {
    return this.axiosInstance
      .post<{ id: string; client_secret: string }>(
        SUBSCRIPTIONS_ENDPOINTS.STRIPE_SESSIONS,
        {
          plan: 'Starter-Yearly',
          is_initial_dashboard_offering: true
        }
      )
      .then((d) => d.data)
  }
}

export default SubscriptionsApi
